<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container class="px-6">
    <page-header>
      {{ $t('restaurantInfo') }}
    </page-header>
    <v-card
      class="mt-4"
      elevation="0"
    >
      <div class="d-flex align-center">
        <div>
          <v-item-group
            v-model="tab"
            mandatory
          >
            <div class="d-flex">
              <v-item v-slot="{active,toggle}">
                <v-btn
                  :color="active?'primary':''"
                  :outlined="!active"
                  class="mr-1 text-caption"
                  rounded
                  small
                  @click="toggle"
                >
                  {{ $t('announcementInformation') }}
                </v-btn>
              </v-item>
              <v-item v-slot="{active,toggle}">
                <v-btn
                  :color="active?'primary':''"
                  :outlined="!active"
                  class="mr-1 text-caption"
                  rounded
                  small
                  @click="toggle"
                >
                  {{ $t('softwareSettings') }}
                </v-btn>
              </v-item>
              <v-item v-slot="{active,toggle}">
                <v-btn
                  :color="active?'primary':''"
                  :outlined="!active"
                  class="mr-1 text-caption"
                  rounded
                  small
                  @click="toggle"
                >
                  {{ $t('storesInformation') }}
                </v-btn>
              </v-item>
              <v-item v-slot="{active,toggle}">
                <v-btn
                  :color="active?'primary':''"
                  :outlined="!active"
                  class="mr-1 text-caption"
                  rounded
                  small
                  @click="toggle"
                >
                  {{ $t('LOGOSetting') }}
                </v-btn>
              </v-item>
              <v-item v-slot="{active,toggle}">
                <v-btn
                  :color="active?'primary':''"
                  :outlined="!active"
                  class="text-caption"
                  rounded
                  small
                  @click="toggle"
                >
                  {{ $t('displaySetting') }}
                </v-btn>
              </v-item>
            </div>
          </v-item-group>
        </div>
        <v-spacer/>
        <v-btn
          v-if="tab===2"
          class="mr-2"
          color="primary"
          elevation="0"
          rounded
          small
          @click="dialog=!dialog"
        >
          <v-icon left>
            mdi-lock
          </v-icon>
          {{ $t('modifyRestaurantInfo') }}
        </v-btn>
        <v-btn
          color="primary"
          elevation="0"
          rounded
          small
          @click="summit()"
        >
          <v-icon left>
            mdi-send
          </v-icon>
          {{ $t('submit') }}
        </v-btn>
      </div>

      <v-card
        class="pa-4 mt-4"
        outlined
      >
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col
                cols="12"
              >
                <span class="text-subtitle-1 font-weight-bold"> {{ $t('restaurantIntroduce') }}</span>
              </v-col>
              <v-col
                cols="12"
              >
                <div class="text-overline">
                  {{ $t('header') }}
                </div>
                <v-text-field
                  v-model="editedItem.buffetAnnouncementHead"
                  dense
                  hide-details
                  outlined
                  placeholder="Willkommen!"
                />
                <div class="text-overline mt-2">
                  {{ $t('body') }}
                </div>
                <v-textarea
                  v-model="editedItem.buffetAnnouncementBody"
                  outlined
                  placeholder="Herzlich Willkommen!"
                />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <div style="display: grid;grid-template-columns: auto 300px;grid-gap: 32px">
              <v-row>
                <v-col
                  cols="12"
                >
                  <span class="text-subtitle-1 font-weight-bold">{{ $t('setting') }}</span>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.totalRound"
                    :label="$t('totalRound')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.maxDineTime"
                    :label="$t('maxDineTime')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.roundTime"
                    :label="$t('roundTime')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.roundDishCount"
                    :label="$t('roundDishCount')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.takeawayPriceModification"
                    :label="$t('takeawayPriceModification')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.childRoundDishCount"
                    :label="$t('childRoundDishCount')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="tableColorDisplay"
                    :label="$t('tableColor')"
                    dense
                    hide-details
                    outlined
                  >
                    <template
                      #append
                    >
                      <v-menu
                        v-model="tableColorMenu"
                        :close-on-content-click="false"
                        nudge-bottom="105"
                        nudge-left="16"
                        top
                      >
                        <template #activator="{ on }">
                          <div
                            :style="swatchStyle"
                            v-on="on"
                          />
                        </template>
                        <v-card>
                          <v-card-text
                            class="pa-0"
                          >
                            <v-color-picker
                              v-model="tableColorDisplay"
                              flat
                              mode="hsla"
                            />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="callColorDisplay"
                    :label="$t('callColor')"
                    dense
                    hide-details
                    outlined
                  >
                    <template
                      #append
                    >
                      <v-menu
                        v-model="callColorMenu"
                        :close-on-content-click="false"
                        nudge-bottom="105"
                        nudge-left="16"
                        top
                      >
                        <template #activator="{ on }">
                          <div
                            :style="swatchStyleCall"
                            v-on="on"
                          />
                        </template>
                        <v-card>
                          <v-card-text
                            class="pa-0"
                          >
                            <v-color-picker
                              v-model="callColorDisplay"
                              flat
                              mode="hsla"
                            />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <span class="text-subtitle-1 font-weight-bold">{{ $t('togoSetting') }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-select
                      v-model="editedItem.currentlyOpening"
                      :items="takeawayOption"
                      :label="$t('closeTakeaway')"
                      dense
                      hide-details
                      item-text="name"
                      item-value="id"
                      outlined
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.letterOnExternalOrder"
                      :label="$t('letterAhead')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.ZBonEmail"
                      :label="$t('ZBon Email')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.minimumDeliveryFee"
                      :label="$t('minimumDeliveryAmountForTOGO')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div style="display: grid;grid-template-columns: auto 300px;grid-gap: 32px">
              <v-row>
                <v-col
                  cols="12"
                >
                  <span class="text-subtitle-1 font-weight-bold">{{ $t('restaurantInfoAndSetting') }}</span>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    :disabled="modifyRight"
                    :label="$t('username')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.adress1"
                    :disabled="modifyRight"
                    :label="$t('adress1')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.adress2"
                    :disabled="modifyRight"
                    :label="$t('adress2')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.postCode"
                    :disabled="modifyRight"
                    :label="$t('postCode')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.city"
                    :disabled="modifyRight"
                    :label="$t('city')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.state"
                    :disabled="modifyRight"
                    :label="$t('state')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.taxNumber"
                    :disabled="modifyRight"
                    :label="$t('taxNumber')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedItem.telephone"
                    :disabled="modifyRight"
                    :label="$t('telephone')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="editedItem.latitude"
                    :disabled="modifyRight"
                    :label="$t('latitude')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.longitude"
                    :disabled="modifyRight"
                    :label="$t('longitude')"
                    dense
                    hide-details
                    outlined
                  />
                </v-col>
              </v-row>
              <div>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <span class="text-subtitle-1 font-weight-bold">{{ $t('legalPersonInformation') }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.inhalterName"
                      :disabled="modifyRight"
                      :label="$t('inhalterName')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.inhalterLastName"
                      :disabled="modifyRight"
                      :label="$t('inhalterLastName')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.inhalterTitle"
                      :disabled="modifyRight"
                      :label="$t('inhalterTitle')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="editedItem.emailAddress"
                      :disabled="modifyRight"
                      :label="$t('emailAddress')"
                      dense
                      hide-details
                      outlined
                    />
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col>
                <div class="text-h4 font-weight-bold">
                  {{ $t('LOGO') }}
                </div>
                <div
                  class="mt-4"
                  style="display: grid;grid-template-columns: repeat(2,1fr)"
                >
                  <div style="width: 200px">
                    <div class="text-subtitle-1">
                      {{ $t('orderPrintLogo') }}
                    </div>
                    <div class="text-caption">
                      {{
                        $t('clickToEdit') + ',' + $t('onlyUseBlackWhiteLogo') + ',' + $t('suggestSize') + '500 x 300'
                      }}
                    </div>
                    <v-card
                      class="pa-2 mt-2"
                      color="#fafbfc"
                      elevation="0"
                      height="200px"
                      width="200px"
                      @click="bonLogoDialog=!bonLogoDialog"
                    >
                      <v-img
                        :src="bonLogo"
                        style="position:absolute;top: 8px;
                        left: 8px;right: 8px;bottom:8px;margin:auto"
                      />
                    </v-card>
                  </div>
                  <div>
                    <div class="text-subtitle-1">
                      {{ $t('restaurantLogo') }}
                    </div>
                    <div class="text-caption">
                      {{
                        $t('clickToEdit') + ',' + $t('suggestSize') + '512 x 512'
                      }}
                    </div>
                    <v-card
                      class="pa-2"
                      color="#fafbfc"
                      elevation="0"
                      height="200px"
                      width="200px"
                      @click="buffetLogoDialog=!buffetLogoDialog"
                    >
                      <v-img
                        :src="buffetLogo"
                        style="position:absolute;top: 8px;
                        left: 8px;right: 8px;bottom:8px;margin:auto"
                      />
                    </v-card>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-dialog
              v-model="bonLogoDialog"
              max-width="300px"
            >
              <v-card class="pa-4">
                <div class="text-h3">
                  {{ $t('editLogo') }}
                </div>

                <v-img
                  :src="bonLogo"
                  class="mt-4 "
                  width="100%"
                />
                <v-file-input
                  :label="$t('uploadTheImage')"
                  accept="image/*"
                  counter
                  prepend-icon="mdi-camera"
                  show-size
                  @change="processFile"
                />
                <v-btn
                  block
                  class="mt-4"
                  color="primary"
                  dark
                  elevation="0"
                  @click="bonLogoSave"
                >
                  {{ $t('save') }}
                </v-btn>
                <v-card-actions/>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="buffetLogoDialog"
              max-width="300px"
            >
              <v-card class="pa-4">
                <div class="text-h3">
                  {{ $t('editLogo') }}
                </div>

                <v-img
                  :src="buffetLogo"
                  class="mt-4 "
                  width="100%"
                />
                <v-file-input
                  :label="$t('uploadTheImage')"
                  accept="image/*"
                  counter
                  prepend-icon="mdi-camera"
                  show-size
                  @change="processFileBuffet"
                />
                <v-btn
                  block
                  class="mt-4"
                  color="primary"
                  dark
                  elevation="0"
                  @click="buffetLogoSave"
                >
                  {{ $t('save') }}
                </v-btn>
                <v-card-actions/>
              </v-card>
            </v-dialog>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col>
                <div class="text-h4 font-weight-bold">
                  {{ $t('displaySetting') }}
                </div>
                <div
                  class="mt-4"
                  style="display: grid;grid-template-columns: repeat(2,1fr)"
                >
                  <div style="width: 200px">
                    <div class="text-subtitle-1">
                      {{ $t('currentVersion') }}
                    </div>
                    <div style="display: grid;grid-template-columns: repeat(2,200px);grid-gap: 24px">
                      <v-card
                        :dark="!!restaurantVersion"
                        class="pa-2"
                        outlined
                        @click="restaurantVersion=1"
                      >
                        <v-img
                          :src="require('@/assets/restaurantVersion.jpg')"
                          height="200"
                          width="100%"
                        />

                        <div class="text-body-1 mt-2">
                          {{ $t('restaurantManager') }}
                        </div>
                        <div class="text-body-2 mt-2">
                          {{ $t('managerTableSupportOrder') }}
                        </div>
                      </v-card>
                      <v-card
                        :dark="!restaurantVersion"
                        class="pa-2"
                        outlined
                        @click="restaurantVersion=0"
                      >
                        <v-img
                          :src="require('@/assets/shopVersion.jpg')"
                          height="200"
                          width="100%"
                        />

                        <div class="text-body-1 mt-2">
                          {{ $t('drinkManager') }}
                        </div>
                        <div class="text-body-2 mt-2">
                          {{ $t('managerTableSupportOrder') }}
                        </div>
                      </v-card>
                    </div>
                  </div>
                  <div style="width: 200px">
                    <div class="text-subtitle-1">
                      Enable StorageManagement
                      <v-checkbox v-model="showStorageManagement"/>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('obtainModificationPermission') }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="modifyPsw"
            :label="$t('inputPassword')"
            :messages="noteShow"
            type="password"
          />
          <v-btn
            block
            class="mt-4"
            color="primary"
            elevation="0"
            @click="pswConfirm"
          >
            {{ $t('accessPermissions') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

  import { editUserInfo, getRestaurantInfo, ifReserveOpen, updateRestaurantInfo } from '@/common/Utlis/api'
  import GlobalSettings, { Remember } from '@/GlobalSettings'
  import store from '../../../store'
  import hillo from 'hillo'
  import { rundTimeSecondToMin } from '@/common/common'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import { showSuccessMessage, sureTo } from '@/common/utils'

  const config = require('@/assets/config.json')

  export default {
    components: { PageHeader },
    data: function () {
      return ({
        restaurantVersion: Remember.restaurantVersion,
        tab: null,
        modifyPsw: '',
        dialog: null,
        bonLogoDialog: null,
        buffetLogoDialog: null,
        uploadBonLogoFile: null,
        uploadBuffetLogoFile: null,
        modifyRight: true,
        noteShow: '',
        statusList: [{
          id: '0',
          name: this.$i18n.t('YES'),
        }, {
          id: '1',
          name: this.$i18n.t('NO'),
        }],
        languageList: [{
          id: '0',
          name: this.$i18n.t('zh'),
        }, {
          id: '1',
          name: this.$i18n.t('en'),
        }, {
          id: '2',
          name: this.$i18n.t('de'),
        }],
        statusItem: {
          id: '',
          name: '',
        },
        langItem: {
          id: '',
          name: '',
        },
        loading: true,
        search: '',
        desserts: [],
        resinfo: {},
        editedIndex: -1,
        takeawayOption: [
          {
            id: '0',
            name: 'Close',
          },
          {
            id: '1',
            name: 'Open',
          },
        ],
        externalLetter: '',
        editedItem: {
          name: '',
          adress1: '',
          adress2: '',
          postCode: '',
          city: '',
          state: '',
          taxNumber: '',
          telephone: '',
          latitude: '',
          longitude: '',
          inhalterName: '',
          inhalterLastName: '',
          inhalterTitle: '',
          emailAddress: '',
          totalRound: '',
          maxDineTime: '',
          roundTime: '',
          roundDishCount: '',
          takeawayPriceModification: '',
          childRoundDishCount: '',
          tableColor: '',
          callColor: '',
          bonLogo: '',
          buffetLogo: '',
          currentlyOpening: '',
          letterOnExternalOrder: '',
          ZBonEmail: '',
        },
        tableColorDisplay: '',
        tableColorMenu: false,
        callColorDisplay: '',
        callColorMenu: false,
        closeTakeAway: ['False', 'True'],
        RInfoAdvertisement: '',
        showStorageManagement: Remember.showStorageManagement === '1',
      })
    },
    computed: {
      bonLogo: function () {
        return this.editedItem.bonLogo
      },
      buffetLogo: function () {
        return this.editedItem.buffetLogo
      },
      swatchStyle () {
        const {
          tableColorDisplay,
          tableColorMenu,
        } = this
        return {
          backgroundColor: tableColorDisplay,
          cursor: 'pointer',
          height: '30px',
          width: '30px',
          borderStyle: 'solid',
          borderColor: '#c1c1c1',
          borderWidth: '1px',
          borderRadius: tableColorMenu ? '50%' : '4px',
          transition: 'border-radius 200ms ease-in-out',
        }
      },
      swatchStyleCall () {
        const {
          callColorDisplay,
          callColorMenu,
        } = this
        return {
          backgroundColor: callColorDisplay,
          cursor: 'pointer',
          height: '30px',
          width: '30px',
          borderStyle: 'solid',
          borderColor: '#c1c1c1',
          borderWidth: '1px',
          borderRadius: callColorMenu ? '50%' : '4px',
          transition: 'border-radius 200ms ease-in-out',
        }
      },
    },
    watch: {
      restaurantVersion (val) {
        Remember.restaurantVersion = val
        setTimeout(() => {
          location.reload()
        }, 500)
      },
      showStorageManagement (val) {
        Remember.showStorageManagement = val ? 1 : 0
        setTimeout(() => {
          location.reload()
        }, 500)
      },
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      processFile (event) {
        this.uploadBonLogoFile = event
        this.editedItem.bonLogo = URL.createObjectURL(event)
      },

      processFileBuffet (event) {
        this.uploadBuffetLogoFile = event
        this.editedItem.buffetLogo = URL.createObjectURL(event)
      },

      async bonLogoSave () {
        await hillo.postWithUploadFile('Restaurant.php?op=changeBonLogo', {
          file: this.uploadBonLogoFile,
        }, { showLoading: true })
        this.bonLogoDialog = false
      },

      async buffetLogoSave () {
        await hillo.postWithUploadFile('Restaurant.php?op=changeBuffetLogo', {
          file: this.uploadBuffetLogoFile,
        }, { showLoading: true })
        this.buffetLogoDialog = false
      },

      async initialize () {
        const res = await getRestaurantInfo()
        this.editedItem = res.content[0]

        // second and min exchange
        this.editedItem = rundTimeSecondToMin(this.editedItem)

        this.statusItem.id = GlobalSettings.isShowOnTable
        for (const i of this.languageList) {
          if (i.name === this.$i18n.t(localStorage.getItem('lang'))) {
            this.langItem.id = i.id
          }
        }

        this.tableColorDisplay = this.editedItem.tableColor
        this.callColorDisplay = this.editedItem.callColor
        if (this.editedItem.bonLogo) {
          const tmpArr = this.editedItem.bonLogo.split('/../')
          this.editedItem.bonLogo = store.getters.rootUrl + tmpArr[1]
        }

        if (this.editedItem.buffetLogo) {
          this.editedItem.buffetLogo = store.getters.rootUrl + this.editedItem.buffetLogo
        }
      },
      async summit () {
        this.editedItem.tableColor = this.tableColorDisplay
        this.editedItem.callColor = this.callColorDisplay
        await sureTo(
          async () => {
            await updateRestaurantInfo(this.editedItem)
            const result = JSON.parse((await ifReserveOpen()))
            console.log(result, 'result')
            if (result.code === 200 && result.data.userAvailable === false) {
              await editUserInfo({
                subDominName: result.data.userDominName.toLowerCase(),
                mapUrl: result.data.mapUrl,
              })
            }
            showSuccessMessage(this.$t('submit_success'))
            await this.initialize()
          },
          'you want to summit？')
      },
      selectStatus (i) {
        if (i === '0') {
          localStorage.setItem('isShowOnTable', '0')
        } else {
          localStorage.setItem('isShowOnTable', '1')
        }
        this.$router.go(0)
      },
      selectLangs (i) {
        this.$i18n.locale = config.supportLang[i].lang
        localStorage.setItem('lang', this.$i18n.locale)
        this.$router.go(0)
      },
      close () {
        this.dialog = false
        this.editedIndex = -1
      },
      pswConfirm () {
        if (this.modifyPsw === store.state.modifyClientInfoPsw) {
          this.modifyRight = false
          this.dialog = !this.dialog
          this.noteShow = ''
        } else {
          this.noteShow = 'Das Passwort ist inkorrekt!'
        }
      },
    },
  }
</script>
